import { getDateInFormat } from "@domains/utils/reportDates";
export var expiryDateMappers = function (data) {
    var _a, _b, _c;
    var dateEntity = {};
    if (data) {
        dateEntity.type = data === null || data === void 0 ? void 0 : data.type;
        dateEntity.curSymList =
            (data === null || data === void 0 ? void 0 : data.curSymList) && ((_a = data === null || data === void 0 ? void 0 : data.curSymList) === null || _a === void 0 ? void 0 : _a.length) > 0 ? data === null || data === void 0 ? void 0 : data.curSymList : [];
        dateEntity.dervSymList =
            (data === null || data === void 0 ? void 0 : data.dervSymList) && ((_b = data === null || data === void 0 ? void 0 : data.dervSymList) === null || _b === void 0 ? void 0 : _b.length) > 0
                ? data === null || data === void 0 ? void 0 : data.dervSymList
                : [];
        dateEntity.validExpiry =
            (data === null || data === void 0 ? void 0 : data.validExpiry) && ((_c = data === null || data === void 0 ? void 0 : data.validExpiry) === null || _c === void 0 ? void 0 : _c.length) > 0
                ? data === null || data === void 0 ? void 0 : data.validExpiry
                : [];
    }
    return dateEntity;
};
var dateListPush = function (dateList, toList) {
    dateList.map(function (dateFinalObj) {
        var dateObj = {
            title: dateFinalObj,
            value: getDateInFormat(dateFinalObj, "YYYY-MM-DD"),
        };
        toList.push(dateObj);
    });
    return toList;
};
export var getExpiryList = function (data, ins, idx) {
    var list = [];
    if (data && data.length > 0) {
        data.map(function (instrument) {
            if (instrument.ins === ins) {
                if (instrument.exp && instrument.exp.length > 0) {
                    instrument.exp.map(function (expList) {
                        if (expList.idx === idx) {
                            list = expList.expLst;
                        }
                    });
                }
            }
        });
    }
    return list;
};
